import { Callback } from 'Types/utilTypes'
import { fork, take } from 'typed-redux-saga'
import { TActionForSelect } from 'Modules'
import { WorkerCache } from 'Helpers'

export const prepareDictData = (res, key) => {
	if (Array.isArray(res)) {
		if (typeof res?.[0] === 'string')
			return res
				.filter((code: string) => code !== '')
				.map((code) => ({
					id: code,
					name: code,
				}))
		return res
	}
	return res?.[key]
}

export const takeEveryUniqueByKey = (actionType: string, saga: Callback, ...args: unknown[]) =>
	fork(function* worker() {
		while (true) {
			const action = yield* take<TActionForSelect>(actionType)
			const { params, key } = action.payload
			const stringifyParams = JSON.stringify(params)

			if (!WorkerCache.hasCache(key, stringifyParams)) {
				WorkerCache.setCache(key, stringifyParams)
				yield* fork(saga, ...args.concat(action))
			}
		}
	})
